class GiolippoLookbookSlider {
  constructor(root) {
    this.root = root;
    this.track = root.querySelector('[data-lookbook-track]');
    this.slides = Array.from(root.querySelectorAll('[data-lookbook-slide]'));
    this.prevButton = root.querySelector('[data-lookbook-prev]');
    this.nextButton = root.querySelector('[data-lookbook-next]');
    this.status = root.querySelector('[data-lookbook-status]');
    this.currentIndex = 0;
    this.animating = false;
    this.enabled = Boolean(window.gsap) && this.slides.length > 1;

    if (!this.track || this.slides.length === 0) return;

    if (this.enabled) {
      this.prepare();
      this.bindEvents();
      this.updateStatus();
    }
  }

  prepare() {
    this.root.classList.add('is-slider-ready');
    this.slides.forEach((slide, index) => {
      slide.classList.toggle('is-active', index === 0);
      if (index === 0) {
        window.gsap.set(slide, { autoAlpha: 1, xPercent: 0 });
      } else {
        window.gsap.set(slide, { autoAlpha: 0, xPercent: 12 });
      }
    });
  }

  bindEvents() {
    if (this.prevButton) {
      this.prevButton.addEventListener('click', () => this.showSlide(this.currentIndex - 1));
    }
    if (this.nextButton) {
      this.nextButton.addEventListener('click', () => this.showSlide(this.currentIndex + 1));
    }
  }

  showSlide(targetIndex) {
    if (!this.enabled || this.animating) return;

    const total = this.slides.length;
    const newIndex = (targetIndex + total) % total;
    if (newIndex === this.currentIndex) return;

    const direction = targetIndex > this.currentIndex ? 1 : -1;
    const currentSlide = this.slides[this.currentIndex];
    const nextSlide = this.slides[newIndex];

    this.animating = true;
    nextSlide.classList.add('is-active');

    window.gsap
      .timeline({
        defaults: { duration: 0.6, ease: 'power2.out' },
        onComplete: () => {
          currentSlide.classList.remove('is-active');
          this.currentIndex = newIndex;
          this.animating = false;
          this.updateStatus();
        },
      })
      .set(nextSlide, { autoAlpha: 0, xPercent: 12 * direction })
      .to(currentSlide, { autoAlpha: 0, xPercent: -12 * direction }, 0)
      .to(nextSlide, { autoAlpha: 1, xPercent: 0 }, 0);
  }

  updateStatus() {
    if (this.status) {
      this.status.textContent = `${this.currentIndex + 1} / ${this.slides.length}`;
    }
  }
}

function initGiolippoLookbookSliders(scope = document) {
  const sliders = scope.querySelectorAll('[data-lookbook-slider]');
  sliders.forEach((slider) => {
    if (!slider.__giolippoLookbook) {
      slider.__giolippoLookbook = new GiolippoLookbookSlider(slider);
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initGiolippoLookbookSliders();
});

document.addEventListener('shopify:section:load', (event) => {
  initGiolippoLookbookSliders(event.target);
});
